<template>
  <div class="common-limit">
    <Breadcrumb></Breadcrumb>
    <div class="table-body">
      <div style="overflow:hidden;margin: 0 0 8px 0;">
        <div style="float:left;">
          <el-button type="primary" size="small" @click="handleAdd"
            >新增</el-button
          >
        </div>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
        />
      </div>
      <el-table :data="noticeList" border>
        <el-table-column label="站点名称" align="center" prop="siteName">
          <template slot-scope="scope">
            <a
              style="cursor:pointer;"
              @click.prevent="handleUpdate(scope.row)"
              >{{ scope.row.siteName }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          label="站点账号"
          align="center"
          prop="userName"
          width="140"
        />
        <el-table-column
          v-if="false"
          label="站点姓名"
          align="center"
          prop="nickName"
          width="140"
        />
        <el-table-column
          label="商家数"
          align="center"
          prop="sellerCnt"
          width="140"
        />
        <el-table-column
          label="联系电话"
          align="center"
          prop="phoneNumber"
          width="140"
        />
        <el-table-column label="邮箱" align="center" prop="email" width="140" />
        <el-table-column
          label="办公地址"
          align="center"
          prop="addr"
          width="140"
        />
        <el-table-column label="站点域名" align="center" prop="siteDomain" />
        <el-table-column
          label="备案号"
          align="center"
          prop="caseNo"
          width="140"
        />
        <el-table-column
          label="推广文案"
          align="center"
          prop="promote"
          width="140"
        />
        <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
          width="100"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleUpdate(scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>

    <!-- 添加或修改公告对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="open"
      width="800px"
      append-to-body
      class="notice-dialog"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="115px">
        <el-row class="notice-dia-row">
          <el-col>
            <el-form-item label="站点名称：" prop="siteName">
              <el-input
                v-model="form.siteName"
                placeholder="请输入站点名称"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="站点账号：" prop="userName">
              <el-input
                v-model="form.userName"
                placeholder="请输入站点账号"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="联系电话：" prop="phoneNumber">
              <el-input
                v-model="form.phoneNumber"
                placeholder="请输入联系电话"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="邮箱：" prop="email">
              <el-input
                v-model="form.email"
                placeholder="请输入邮箱"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="办公地址：" prop="addr">
              <el-input
                v-model="form.addr"
                placeholder="请输入办公地址"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="站点域名：" prop="siteDomain">
              <el-input
                v-model="form.siteDomain"
                placeholder="请输入站点域名"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="备案号：" prop="caseNo">
              <el-input
                v-model="form.caseNo"
                placeholder="请输入备案号"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="推广文案：" prop="promote">
              <el-input
                v-model="form.promote"
                placeholder="请输入推广文案"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="个人二维码：">
              <img
                style="float:left; width: 180px;margin: 0 16px 0 0;"
                v-if="form.personalQrUrl"
                :src="form.personalQrUrl"
              />
              <el-upload
                class="upload"
                ref="upload"
                drag
                action="#"
                :file-list="fileListPersonal"
                :auto-upload="false"
                :before-upload="beforeUpload"
                :on-change="handleChangePersonal"
                :multiple="true"
                :limit="1"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="企业二维码：">
              <img
                style="float:left; width: 180px;margin: 0 16px 0 0;"
                v-if="form.enterpriseQrUrl"
                :src="form.enterpriseQrUrl"
              />
              <el-upload
                class="upload"
                ref="upload"
                drag
                action="#"
                :file-list="fileListEnterprise"
                :auto-upload="false"
                :before-upload="beforeUpload"
                :on-change="handleChangeEnterprise"
                :multiple="true"
                :limit="1"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="首页LOGO：">
              <img
                style="float:left; width: 180px;margin: 0 16px 0 0;"
                v-if="form.homeLogoUrl"
                :src="form.homeLogoUrl"
              />
              <el-upload
                class="upload"
                ref="upload"
                drag
                action="#"
                :file-list="fileListHome"
                :auto-upload="false"
                :before-upload="beforeUpload"
                :on-change="handleChangeHome"
                :multiple="true"
                :limit="1"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="登录页LOGO：">
              <img
                style="float:left; width: 180px;margin: 0 16px 0 0;"
                v-if="form.loginLogoUrl"
                :src="form.loginLogoUrl"
              />
              <el-upload
                class="upload"
                ref="upload"
                drag
                action="#"
                :file-list="fileListLogin"
                :auto-upload="false"
                :before-upload="beforeUpload"
                :on-change="handleChangeLogin"
                :multiple="true"
                :limit="1"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="设计器LOGO：">
              <img
                style="float:left; width: 180px;margin: 0 16px 0 0;"
                v-if="form.designLogoUrl"
                :src="form.designLogoUrl"
              />
              <el-upload
                class="upload"
                ref="upload"
                drag
                action="#"
                :file-list="fileListDesign"
                :auto-upload="false"
                :before-upload="beforeUpload"
                :on-change="handleChangeDesign"
                :multiple="true"
                :limit="1"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" size="small"
          >确 定</el-button
        >
        <el-button @click="cancel" size="small">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="detailVisible"
      destroy-on-close
    >
      <div>
        <div
          style="font-size: 20px;border-bottom: 1px solid #EBEEF5; text-align: center;line-height: 40px"
        >
          {{ detailInfo.questionTitle }}
        </div>
        <div style="text-align: center; line-height: 40px">
          <span>更新时间: {{ detailInfo.createTime }}</span>
        </div>
        <div v-html="detailInfo.content"></div>
      </div>
      <div slot="footer">
        <el-button size="small" @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <LocalUpload :ckData="localUploadData"></LocalUpload>
    <OnlineUpload :ckData="onlineUploadData"></OnlineUpload>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import LocalUpload from "@/components/common/ckEditorUploadPage/localUpload"
import OnlineUpload from "@/components/common/ckEditorUploadPage/onlineUpload"
import { setSite, getSite } from "@/api/sysSupport/site"
import CKEditor4 from "@/components/common/CKEditor"
import { uploadFile } from "@/api/upload/upload"

export default {
  name: "siteManage",
  components: {
    CKEditor4,
    Breadcrumb,
    LocalUpload,
    OnlineUpload,
  },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 公告表格数据
      noticeList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 类型数据字典
      statusOptions: [],
      // 状态数据字典
      typeOptions: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        questionTitle: undefined,
        createBy: undefined,
        questionStatus: undefined,
        time: [],
      },
      // 表单参数
      form: {
        siteName: "",
        userName: "",
        phoneNumber: "",
        email: "",
        addr: "",
        siteDomain: "",
        caseNo: "",
        promote: "",
        personalQr: "",
        enterpriseQr: "",
        homeLogo: "",
        loginLogo: "",
        designLogo: "",
        homeLogoUrl: "",
        loginLogoUrl: "",
        designLogoUrl: "",
        personalQrUrl: "",
        enterpriseQrUrl: "",
      },
      // 表单校验
      rules: {
        siteName: [
          { required: true, message: "站点名称不能为空", trigger: "blur" },
        ],
        userName: [
          { required: true, message: "站点账号不能为空", trigger: "blur" },
        ],
        phoneNumber: [
          { required: true, message: "联系电话不能为空", trigger: "blur" },
        ],
        email: [{ required: true, message: "邮箱不能为空", trigger: "blur" }],
        addr: [
          { required: true, message: "办公地址不能为空", trigger: "blur" },
        ],
        siteDomain: [
          { required: true, message: "站点域名不能为空", trigger: "blur" },
        ],
      },
      editor: null,
      editorConfig: {
        allowedContent: true, //设置为true，以防止CKEditor 4删除不允许的元素
        extraPlugins: ["uploadImg"],
        height: "300px",
        toolbar: [
          ["Maximize"],
          ["Bold", "Italic", "Underline", "Strike"],
          ["TextColor", "BGColor"],
          [
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Subscript",
            "Superscript",
          ],
          ["HorizontalRule", "RemoveFormat"],
          ["Undo", "Redo"],
          "/",
          ["Styles", "Format", "Font", "FontSize"],
          ["Table"],
          ["uploadImg"],
        ],
        language: "zh-cn",
        wordcount: {
          showCharCount: true,
        },
      },
      localUploadData: {
        visible: false,
        editor: null,
      },
      onlineUploadData: {
        visible: false,
        editor: null,
      },
      detailVisible: false,
      detailInfo: {},
      fileListPersonal: [],
      fileListEnterprise: [],
      fileListHome: [],
      fileListLogin: [],
      fileListDesign: [],
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
  },
  created() {
    this.getList()
    this.getDicts("sys_notice_status").then((response) => {
      this.statusOptions = response.data
    })
    /* this.getDicts('sys_notice_type').then((response) => {
      this.typeOptions = response.data;
    }); */
  },
  methods: {
    /** 查询公告列表 */
    getList() {
      this.loading = true
      let params = Object.assign({}, this.queryParams)
      if (params.time && params.time.length > 0) {
        params.beginTime = params.time[0]
        params.endTime = params.time[1]
      }

      delete params["time"]
      getSite(params).then((response) => {
        this.noticeList = response.data
        this.loading = false
      })
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!")
      }
      return isLt2M
    },
    handleChangePersonal(file, fileList) {
      this.fileListPersonal = fileList
    },
    handleChangeEnterprise(file, fileList) {
      this.fileListEnterprise = fileList
    },
    handleChangeHome(file, fileList) {
      this.fileListHome = fileList
    },
    handleChangeLogin(file, fileList) {
      this.fileListLogin = fileList
    },
    handleChangeDesign(file, fileList) {
      this.fileListDesign = fileList
    },
    // 公告状态字典翻译
    statusFormat(row, column) {
      return this.selectDictLabel(this.statusOptions, row.status)
    },
    // 公告状态字典翻译
    typeFormat(row, column) {
      return this.selectDictLabel(this.typeOptions, row.noticeType)
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        siteName: "",
        userName: "",
        phoneNumber: "",
        email: "",
        addr: "",
        siteDomain: "",
        caseNo: "",
        promote: "",
        personalQr: "",
        enterpriseQr: "",
        homeLogo: "",
        loginLogo: "",
        designLogo: "",
        homeLogoUrl: "",
        loginLogoUrl: "",
        designLogoUrl: "",
        personalQrUrl: "",
        enterpriseQrUrl: "",
      }
      this.fileListPersonal = []
      this.fileListHome = []
      this.fileListEnterprise = []
      this.fileListLogin = []
      this.fileListDesign = []
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.reset()
      this.resetForm("queryForm")
      // this.handleQuery()
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.questionId)
      this.single = selection.length != 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.title = "新增站点"
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.form = row
      this.open = true
      this.title = "修改站点"
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let form = this._.clone(this.form)
          if (this.fileListPersonal.length > 0) {
            const file = this.fileListPersonal[0]
            if (file.raw) {
              if (true) {
                const { uploadFlag, fileUrl, host } = await uploadFile(file)
                // this.form.personalQr = fileUrl.replace(host, "")
                form.personalQrUrl = fileUrl.replace(host, "")
              }
            }
          }
          if (this.fileListEnterprise.length > 0) {
            const file = this.fileListEnterprise[0]
            if (file.raw) {
              if (true) {
                const { uploadFlag, fileUrl, host } = await uploadFile(file)
                // form.enterpriseQr = fileUrl.replace(host, "")
                form.enterpriseQrUrl = fileUrl.replace(host, "")
              }
            }
          }
          if (this.fileListHome.length > 0) {
            const file = this.fileListHome[0]
            if (file.raw) {
              if (true) {
                const { uploadFlag, fileUrl, host } = await uploadFile(file)
                // form.homeLogo = fileUrl.replace(host, "")
                form.homeLogoUrl = fileUrl.replace(host, "")
              }
            }
          }
          if (this.fileListLogin.length > 0) {
            const file = this.fileListLogin[0]
            if (file.raw) {
              if (true) {
                const { uploadFlag, fileUrl, host } = await uploadFile(file)
                // form.loginLogo = fileUrl.replace(host, "")
                form.loginLogoUrl = fileUrl.replace(host, "")
              }
            }
          }
          if (this.fileListDesign.length > 0) {
            const file = this.fileListDesign[0]
            if (file.raw) {
              if (true) {
                const { uploadFlag, fileUrl, host } = await uploadFile(file)
                // form.designLogo = fileUrl.replace(host, "")
                form.designLogoUrl = fileUrl.replace(host, "")
              }
            }
          }

          setSite(form).then((response) => {
            if (response.code === 200) {
              this.msgSuccess("新增成功")
              this.open = false
              this.reset()
              this.getList()
            }
          })
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const questionIds = row.questionId || this.ids
      this.$confirm(
        '是否确认删除公告编号为"' + questionIds + '"的数据项?',
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(function() {
          return deleteHelp(questionIds)
        })
        .then(() => {
          this.getList()
          this.msgSuccess("删除成功")
        })
        .catch(function() {})
    },
    getEditor(editor) {
      this.editor = this.localUploadData.editor = this.onlineUploadData.editor = editor
    },
    openUploadDialog(val) {
      if (val == "local") {
        this.localUploadData.visible = true
      } else if (val == "online") {
        this.onlineUploadData.visible = true
      }
    },
    handleShowDetail(row) {
      this.detailInfo = row
      this.detailVisible = true
    },
  },
}
</script>
<style scoped>
.notice-dia-row {
  margin: 10px;
}
.notice-dialog .el-dialog__footer {
  padding: 10px !important;
}
.notice-dialog ::v-deep .el-dialog__body {
  height: 60vh;
  overflow-y: auto;
}
.upload {
  float: left;
}
.upload ::v-deep .el-upload {
  width: 200px;
}
.upload ::v-deep .el-upload-dragger {
  width: 200px;
}
</style>
